<template>
  <div class="base-loader">
    <div
        class="spinner-border"
        style="width: 3rem; height: 3rem"
        role="status"
      >
        <span class="visually-hidden">Loading...</span>
      </div>
  </div>
</template>

<script>

export default {
  name: "baseLoader",
  components: {},
  props: {
    
  },

  created() {
    
  },

  data: function () {
    return {
      
    };
  },
  methods: {
    
  },
  watch: {
    
  },
  computed: {},
};
</script>
